import { createAction, props } from '@ngrx/store';
import { RadiusFilterOption } from '@immosky/types';

export enum RadiusActions {
  Reset = '[Filter] Reset Radius Filter',
  Set = '[Filter] Set Radius Filter',
  SetBasedOnValues = '[Filter] Set Radius Filter Based On Values',
}

export const resetRadiusFilter = createAction(RadiusActions.Reset);

export const setRadiusFilter = createAction(
  RadiusActions.Set,
  props<{ filter: RadiusFilterOption }>()
);

export const setRadiusFilterBasedOnUrlValue = createAction(
  RadiusActions.SetBasedOnValues,
  props<{ value: number }>()
);
